export enum SearchTarget {
    dispatch = 1,
    quote = 2,
    order = 3,
    invoice = 4,
    inventory = 5,
    quoteTemplate = 6,
    vendorCredit = 7,
    vendorReturn = 8,
    contract = 9,
    job = 10,
    dispatchBoard = 100,
    any = 0,
    vehicle = 11,
    Supplier = 12,
    AssetsTracking = 13,
    AssetWarehouse = 14,
    BillingCode = 15,
    parts = 16,
    employee = 17,
    inventoryLocation = 18,
    landing = 20,
    appRoot = 100,
    orderBill =21
}

